import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useIonRouter } from "@ionic/react";
import { MatchPhone } from "refsix-js-models";

import { trackEvent } from "../../services/analytics/analyticsService";
import {
    headerTapProps,
    LEADERBOARD_RIBBON_TAPPED,
    LeaderboardTapContext,
} from "../../pages/venue/leaderboardAnalytics";
import { useVenueRibbons } from "./useVenueRibbons";
import "./venueRibbons.css";

export interface VenueHeaderProps {
    venueName: string;
    venueRoute: string;
    analytics: LeaderboardTapContext;
}

export const VenueHeader: FC<VenueHeaderProps> = ({
    venueName,
    venueRoute,
    analytics,
}) => {
    const { t } = useTranslation();
    const router = useIonRouter();

    return (
        <button
            type="button"
            className="venue-header"
            data-testid="venue-header"
            onClick={() => {
                trackEvent(
                    LEADERBOARD_RIBBON_TAPPED,
                    headerTapProps(analytics)
                );
                router.push(venueRoute, "forward");
            }}
        >
            <span className="venue-header-name">
                <span aria-hidden="true">📍 </span>
                {venueName}
            </span>
            <span className="venue-header-link">
                {t("leaderboards.Header.leaderboard")}
                <span aria-hidden="true"> →</span>
            </span>
        </button>
    );
};

/** Shares `useVenueRibbons`' gate, so it shows only for a server-tagged match. */
export const MatchVenueHeader: FC<{ match: MatchPhone }> = ({ match }) => {
    const { available, venueName, venueRoute, analytics } =
        useVenueRibbons(match);

    if (!available || !venueName) {
        return null;
    }

    return (
        <VenueHeader
            venueName={venueName}
            venueRoute={venueRoute}
            analytics={analytics}
        />
    );
};
